import * as actions from './actions';
import * as mutations from './mutations';

export default {
  namespaced: true,
  state: () => ({
    uid: -1,
    cropInfo: {},
    cropInfoTemp: { ratioLabel: '原图', ratioValue: 'original', changeFlag: 0, width: 0, height: 0, left: 0, top: 0 },
    cropOriginImage: '',
    currentMenuAction: '',
    userInfo: {
      UserKey: '',
      TextTransKey: '',
    },
    // 属性编辑器类型
    currentPropsEditorType: 'textbox',
    topOneUid: -1,
    downloading: false,
    // 下载的图片文件名
    downloadName: '',
    // 文件扩展名
    imageExtenssion: 'png',
    imageQuality: 1,
    loadDataError: '',
    isColorPicking: false,
    editorLoading: true, // 加载数据loading
    editorImageLoading: false, // 加载图片loading，时间会久点
    isCompareMode: false,
    canvasScale: 1,
    canvasMaxScale: 1.5,
    canvasMinScale: 0.4,
    WatermarkLayerUrl: '',
    isSpaceBarPressed: false,
    isCanvasGrabing: false,
    // 是否正在进行处理撤销重做引起的重新渲染
    isUndoRedoRendering: false,
    RmUrl: '',
    OriginUrl: '',
    OriginUrlRemote: '',
    // 现在是否有group存在
    isGrouping: false,
    // 有组存在的时候用于存储组里激活的object的所有uid
    groupUids: [],
    // 存放uid列表，用于控制层级
    objectUIDs: [],
    // 存放{uid:object}，用于存放fabric里的object
    objectMap: {},
    // 存放{uid:objectProps}，用于存放fabric里的object的属性props
    objectPropsMap: {},
    // 被选中的uid
    selectedObjectUid: -1,
    // 是否可以进行历史记录了，初始化的过程这个值为false，第一次renderAll之后为true
    appReady: false,
    editorSize: {
      wrapWidth: 0,
      wrapHeight: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      gap: 10,
      canvasReady: false,
    },
    isDrawingMode: false,

    // 修复
    isInpaintMode: false,
    inpainting: false,
    // 智能修复模式
    isAiInpaintMode: false,
    isDraw2CancelTransMode: false, // 是否为笔刷取消翻译模式
    inpaintCursorPosition: {},
    inpaintInstalling: false, // 正在安装opencv.js
    inpaintInstalled: false, // opencv.js已安装

    canvasBGImage: '',
    drawingConfig: {
      brushWidth: 20,
      brushColor: '#fcf8f9',
    },
    manualSortedUids: [],
    sourceLanguage: '',
    targetLanguage: '',
    HasWatermark: false,
    // 复制object临时存的id
    copyUID: '',
    // postmessage响应给调用方信息时，是否返回图片base64
    returnBase64: false,
  }),
  getters: {
    croppedCanvasWidth(state) {
      return state.cropInfo.width || state.editorSize.canvasWidth;
    },
    croppedCanvasHeight(state) {
      return state.cropInfo.height || state.editorSize.canvasHeight;
    },
    selectedObject(state) {
      return state.objectMap[state.selectedObjectUid];
    },
    selectedObjectProps(state) {
      return state.objectPropsMap[state.selectedObjectUid];
    },
    disabledScaleSmaller(state) {
      return state.canvasScale <= state.canvasMinScale;
    },
    disabledScaleLarger(state) {
      return state.canvasScale >= state.canvasMaxScale;
    },
  },
  mutations,
  actions,
};
